
import { useNavigate } from "react-router-dom";
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton } from '@mui/material'

import './dialogStyle.css'
import iconAnular from './iconAnular.svg'

import { Model } from '../../../models/model'

export const DialogDelete = ({ invoiceId, open, setOpen }) => {

    const navigate = useNavigate();

    const handleDelete = async () => {
        await Model.delete({
            url: `invoices/delete/${invoiceId}`
        })

        navigate(-1)

        setOpen(false)
        
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>
                    <img src={iconAnular} alt="arrow" />
                </div>
                <div className='text mt-3'>
                    Confirmar eliminación
                </div>
                <p className='p-text-emisor'>Esta acción dará por eliminado la factura. Descontando lo facturado al ppto asociado.</p>
            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='approve' onClick={handleDelete}>Sí. Eliminar</button>
            </DialogActions>
        </Dialog>
    );

}